module.exports = __webpack_public_path__ + "static/img/back_btn.4abffd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back_btn.svg
// module id = uOv+
// module chunks = 1